<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="mask0_25079_8232" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="28" height="28">
    <path d="M28 0H0V28H28V0Z" fill="white" />
  </mask>
  <g mask="url(#mask0_25079_8232)">
    <path
      d="M13.9999 1.24081H13.9999C6.95318 1.24081 1.24072 6.95327 1.24072 13.9999V14C1.24072 21.0467 6.95318 26.7592 13.9999 26.7592H13.9999C21.0466 26.7592 26.7591 21.0467 26.7591 14V13.9999C26.7591 6.95327 21.0466 1.24081 13.9999 1.24081Z"
      fill="#ECEAFF" />
    <path
      d="M13.9999 1.24081H13.9999C6.95318 1.24081 1.24072 6.95327 1.24072 13.9999V14C1.24072 21.0467 6.95318 26.7592 13.9999 26.7592H13.9999C21.0466 26.7592 26.7591 21.0467 26.7591 14V13.9999C26.7591 6.95327 21.0466 1.24081 13.9999 1.24081Z"
      stroke="#2F2A4A" stroke-width="1.3411" />
    <g filter="url(#filter0_i_25079_8232)">
      <path
        d="M7.30722 14.8897C7.30722 18.5772 10.2802 21.578 13.9343 21.578C17.5884 21.578 20.5199 18.8864 20.5199 13.7997C20.5199 13.7997 17.2925 13.9955 14.4871 12.7951C11.7177 11.61 9.94711 9.55014 9.94711 9.55014C8.30082 10.8049 7.30722 12.781 7.30722 14.8897ZM4.84316 12.1877C5.83292 7.14032 10.7069 3.84634 15.7084 4.84518C20.7094 5.84446 23.9732 10.7634 22.9834 15.8107C22.8257 16.6145 22.6258 17.2217 22.2116 18.1176C21.8539 18.892 20.9804 19.9734 20.7505 20.2523C19.9623 21.1612 19.0009 21.9002 17.9267 22.4203C17.9267 22.4203 17.8413 22.4493 17.7132 22.5077C15.9541 23.3098 14.0192 23.5329 12.1191 23.1533C7.11727 22.1548 3.85344 17.235 4.84316 12.1877Z"
        fill="#2F2A4A" />
      <path
        d="M9.65601 14.3281C9.65601 14.3281 10.3769 14.0005 10.9662 14.0005C11.6213 14.0005 12.2764 14.3281 12.2764 14.3281"
        stroke="#2F2A4A" stroke-linecap="round" />
      <path
        d="M15.9924 17.9186C16.1157 17.799 16.0291 17.6021 15.8573 17.6021H12.1268C11.9594 17.6021 11.8718 17.79 11.988 17.9106C12.3965 18.334 13.2008 19.0433 14.0051 19.0433C14.7244 19.0433 15.5551 18.3429 15.9924 17.9186Z"
        fill="#2F2A4A" />
    </g>
  </g>
  <defs>
    <filter id="filter0_i_25079_8232" x="4.66626" y="0.684417" width="18.4941" height="22.6489"
      filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha" />
      <feOffset dy="-3.98224" />
      <feGaussianBlur stdDeviation="4.97781" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_25079_8232" />
    </filter>
  </defs>
</svg>